import http from "./httpService";

const endPoint = "/api/v1/Set";

export async function addSet(request) {
    return await http.post(`${endPoint}`, request);
}

export async function updateSet(id, request) {
    return await http.put(`${endPoint}/${id}`,request);
}

export async function getSet(setId) {
    return await http.get(`${endPoint}`, {
        params: {
            id: setId
        }
    });
}

export function getAllSet() {
    return http.get(`${endPoint}/All`);
}

export default { addSet, updateSet, getAllSet, getSet };




// WEBPACK FOOTER //
// ./src/services/SetService.js